//React
import React, { useCallback, useEffect, useState } from "react";
//Libs
import swal from "sweetalert";
import { Modal } from "semantic-ui-react";

//Services
import { producaov2 as api } from "../../../../services/apis";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loading from "../../../../components/Loading";
import { Table, Checkbox } from "semantic-ui-react";
import { FaRegEdit,FaTrashAlt } from "react-icons/fa";

//Styles
import {
  Container, Content,
   Title,
   ActionButtons,
   Field,
   Input,
   Label,
   ButtonModalSubmit
} from "./styles";
import InputSelector from "../../NovoEmpresas/components/InputSelector";

const ListarMapeamento = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [del, setDelete] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [categories, setCategories] = useState([]);

  const closeModalDelete = () => {
    setEdit(false);
    setDelete(false);
  };

  useEffect(() => {
    loadCampaign();
  }, []);

  const loadCampaign = useCallback(
    async () => {
      setLoading(true);
      try {
        const response = await api.get("admin/pep/questions");
        setData(response.data.payload);
        setCategories(response.data.categories)
        // await systemLogs(`/campaign`, `Listou a campanha`);
        setLoading(false);
      } catch (err) {
        swal(`Não foi possível carregar os cursos`, err, "error");
        setLoading(false);
      }
    },
    [search]
  );

  const statusChange = (id) => {

    api
      .put(`admin/pep/question/status/${id}`)
      .then((v) => {
        swal(
          "Status alterado com sucesso",
          "",
          "success"
        );

        loadCampaign();

      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        swal(
          "Ocorreu um erro ao atualizar status!",
          "Houve um erro ao salvar os dados do arquivo enviado. Se o erro persistir, nos contate.",
          "error"
        );
        return false;
      });
  };

  const handleChange = (e)=> {
    setEditId(prev => ({...prev, category: e}))
  };


  const saveUpdate = async (e)=> {
    e.preventDefault();
    try {
      await api.put(`admin/pep/questions/${editId.id}`,editId);

      swal(`Alteração feita com sucesso`,"", "success");
      setEditId(null);
      loadCampaign();
      
    } catch (err) {
      swal(`Não foi possível atualizar o curso`, err, "error");
      loadCampaign();
      setLoading(false);
    }
    
  };



  if(loading) { 
    return (
      <Container>
        <AdminMenu />
        <Content>
        <Title>Controle - Mapeamento de Competências</Title>
        </Content>
      </Container>
    )
  }

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Controle - Mapeamento de Competências</Title>
        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Pergunta</Table.HeaderCell>
            <Table.HeaderCell>Categoria</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Editar </Table.HeaderCell>
          </Table.Header>

          <Table.Body>
            {data &&
              data.map(d => (
                <Table.Row key={d?.id}>
                  <Table.Cell>{d?.id}</Table.Cell>
                  <Table.Cell>{d?.question_text}</Table.Cell>
                  <Table.Cell>{categories.find(item => d?.category === item.id)?.title}</Table.Cell>
                  <Table.Cell> <Checkbox checked={d.active} onClick={() => statusChange(d.id)} toggle /></Table.Cell>
                  {/* <Table.Cell>{mba.is_active ? "S" : "N"}</Table.Cell> */}
                  <Table.Cell>
                    <ActionButtons>
                        <FaRegEdit size={16} color="var(--color-primary)" onClick={() => {setEdit(true);setEditId(d)}} />
                        {/* <FaTrashAlt size={16} color="var(--color-primary)" onClick={() => setDelete(true)} /> */}
                    </ActionButtons>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Content>
      <Modal
        open={edit}
        onClose={closeModalDelete}
        size="tiny"
        // style={{ width: "400px", height: "300px" }}
      >
        {
          editId && (
        <Modal.Content>
              <Field>
                <Label>Pergunta</Label>
                <Input value={editId.question_text} onChange={(e) => setEditId(prev => ({...prev, question_text: e.target.value}))} />
              </Field>
              <Field>
                <Label>Placeholder</Label>
                <Input value={editId.placeholder} onChange={(e) => setEditId(prev => ({...prev, placeholder: e.target.value}))} />
              </Field>
              <Field>
                <Label>Categoria</Label>
                <InputSelector
                  placeholder="Busque pelo nome da categoria"
                  selection
                  noLabel
                  handleChange={handleChange}
                  value={editId.category}
                  options={categories.map(
                    (c, index) => ({
                      key: index,
                      text: `${c.name}`,
                      value: c.id,
                    })
                  )}
              />
              </Field>
              <Field>
                <Label>Seleção(Adicione as opções seguidas de virgula)</Label>
                <Input value={editId.combobox_option} placeholder="Oratória,Lean,Programação,Liderança" onChange={(e) => setEditId(prev => ({...prev, combobox_option: e.target.value}))} />
              </Field>
              <Field>
                <Label>Perguntas Secundárias (Adicione as opções seguidas de virgula)</Label>
                <Input value={editId.subquestions} placeholder="O quanto a Voitto é boa para você?,Quanto você gosta de Lean?" onChange={(e) => setEditId(prev => ({...prev, subquestions: e.target.value}))} />
              </Field>
              <Field>
                  <ButtonModalSubmit onClick={(e)=> saveUpdate(e)}>Salvar</ButtonModalSubmit>
              </Field>
        </Modal.Content>
          )
        }
        
      </Modal>
    </Container>
  );
};

export default ListarMapeamento;
